import React, { useEffect } from 'react'
import { logEvent } from 'firebase/analytics'
import { EHealthProceduresTypes, IHealthProcedures } from '~/interfaces'

import { MedicalNoteDetails } from '~/components/healthProcedures/MedicalNoteDetails'
import { LaboratoryTestDetails } from '~/components/healthProcedures/laboratoryTest/LaboratoryTestDetails'
import { ImagingTestDetails } from '~/components/healthProcedures/ImagingTestDetails'
import { SurgeryDetails } from '~/components/healthProcedures/SurgeryDetails'
import { AnatomopathologicalTestDetails } from '~/components/healthProcedures/AnatomopathologicalTestDetails'
import { MedicalAppointmentDetails } from '~/components/healthProcedures/MedicalAppointmentDetails'
import { VaccineDetails } from '~/components/healthProcedures/VaccineDetails'
import { BirthReportDetails } from '~/components/healthProcedures/BirthReportDetails'
import { EchocardiogramTestDetails } from '~/components/healthProcedures/EchocardiogramTestDetails'
import { DiagnosisDetails } from '~/components/healthProcedures/DiagnosisDetails'
import { analytics } from '~/firebase-analytics'

interface CreateHealthProcedureDetailsProps {
  modalHealthProcedure: IHealthProcedures | null
  handleSelectedModalHealthProcedures: (healthProcedure: IHealthProcedures | null) => void
  selectedPatient: () => number
}

export const CreateHealthProcedureDetails = ({
  modalHealthProcedure,
  handleSelectedModalHealthProcedures,
  selectedPatient
}: CreateHealthProcedureDetailsProps): JSX.Element => {
  const {
    MATERNAL_INFANT_IMAGING_TEST,
    ECHOCARDIOGRAM_TEST,
    RADIOLOGY_IMAGING_TEST,
    LABORATORY_TEST,
    ANATOMOPATHOLOGICAL_TEST,
    SURGERY,
    MEDICAL_APPOINTMENT,
    MEDICAL_NOTE,
    VACCINE,
    BIRTH,
    EVALUATION_BREAST_IMAGING_TEST,
    DIAGNOSIS,
    DIAGNOSIS_BIOPSY,
    DIAGNOSIS_ANATOMOPATHOLOGICAL_TEST
  } = EHealthProceduresTypes

  const detailsComponentMap = {
    [MATERNAL_INFANT_IMAGING_TEST]: ImagingTestDetails,
    [RADIOLOGY_IMAGING_TEST]: ImagingTestDetails,
    [ECHOCARDIOGRAM_TEST]: EchocardiogramTestDetails,
    [LABORATORY_TEST]: LaboratoryTestDetails,
    [ANATOMOPATHOLOGICAL_TEST]: AnatomopathologicalTestDetails,
    [SURGERY]: SurgeryDetails,
    [MEDICAL_APPOINTMENT]: MedicalAppointmentDetails,
    [MEDICAL_NOTE]: MedicalNoteDetails,
    [VACCINE]: VaccineDetails,
    [BIRTH]: BirthReportDetails,
    [EVALUATION_BREAST_IMAGING_TEST]: ImagingTestDetails,
    [DIAGNOSIS]: DiagnosisDetails,
    [DIAGNOSIS_BIOPSY]: ImagingTestDetails,
    [DIAGNOSIS_ANATOMOPATHOLOGICAL_TEST]: AnatomopathologicalTestDetails
  }

  useEffect(() => {
    if (modalHealthProcedure?.type) logEvent(analytics, 'open_medical_event', { type: modalHealthProcedure.type })
  }, [modalHealthProcedure?.type])

  if (!modalHealthProcedure) return <></>

  const DetailedProcedure = detailsComponentMap[modalHealthProcedure.type]

  if (!DetailedProcedure) return <></>

  return (
    <DetailedProcedure
      showModal
      setShowModal={handleSelectedModalHealthProcedures}
      patientId={selectedPatient()}
      healthProcedure={modalHealthProcedure}
    />
  )
}
